<small class="error" *ngIf="showError()" [innerHTML]="message ? message : translateError(getFirstError(control?.errors))"></small>
